<div
  mat-dialog-title
  appDraggableDialog
  draggableKey="change-font"
  [draggableWithRestrictArea]="true"
  dialogClass=".q9-change-font">
  <span>{{ 'ASIDE_R.FONT' | translate }}</span>
</div>

<mat-dialog-content>
  <app-font-configs
    [isCollapse]="false"
    (fontColorSwitch)="setFontColor($event)"
    (switchFont)="setFontStyle($event)"
    (toggleUnorderedList)="toggleUnorderedList()"
    (toggleOrderedList)="toggleOrderedList()"
    [configsShown]="true"
    [buttonsEnabled]="buttonsEnabled"
    [styleObj]="shapeJson.style"
    [controlsMode]="1"
    [listFormatEnabled]="true"></app-font-configs>
</mat-dialog-content>
